const NavMain = props => {
    return (
        <nav className="navbar navbar-light bg-white fixed-top d-flex align-items-center">
            <a className="navbar-brand mr-auto" href="http://www.fao.org/home/en/" target="_blank" rel="noreferrer">
                <img src={props.logo} alt="FAO - Home" />
            </a>

            <button type="button" className="btn btn-dark btn-scroll-top" data-toggle="modal" data-target="#copyrightModal">{props.copyright}</button>
            <button onClick={onClickScrollTop} type="button" id="scrollTop" className="btn btn-dark btn-scroll-top">{props.scroll}</button>
            <div className="dropdown dropleft">
                <button className="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    ES
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a className="dropdown-item" href="http://www.fao.org/sdg-progress-report/2021/en/">EN</a>
                    <a className="dropdown-item" href="http://www.fao.org/sdg-progress-report/2021/fr/">FR</a>
                    <a className="dropdown-item" href="http://www.fao.org/sdg-progress-report/2021/ar/">AR</a>
                    <a className="dropdown-item" href="http://www.fao.org/sdg-progress-report/2021/ru/">RU</a>
                    <a className="dropdown-item" href="http://www.fao.org/sdg-progress-report/2021/zh/">ZH</a>
                </div>
            </div>
        </nav>
    ) 
}

const onClickScrollTop = () => {
    const pages = document.querySelectorAll('.swiper-slide')

    pages.forEach(page => {
        page.scrollTo(0, 0);
    })
}

export default NavMain;
